import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    (Cookies.get("accessToken") && Cookies.get("user")) || false
  );
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const accessToken = Cookies.get("accessToken");
    const userData = Cookies.get("user");

    if (accessToken && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
  }, [Cookies]);

  const logout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("user");
    setIsAuthenticated(false);
    setUser(null);
    navigate("/");
  };
  return { isAuthenticated, user, logout };
};

export default useAuth;
